import type { GoalsResponse } from "@paisa/types"
import { useQuery } from "@tanstack/react-query"
import { api } from "@/lib/api"

export type { GoalsResponse as GoalsData } from "@paisa/types"

export function useGoals() {
  return useQuery({
    queryKey: ["goals"],
    queryFn: () => api.get<GoalsResponse>("/goals"),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}
